import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTheme } from 'styled-components';
import { SectionTitle } from '@/js/libs/ui';
import { Wrapper, Error, Loader, Element, SubElement } from './styles';
export const ErrorScreen = memo(function ErrorScreen({ className, error, title = 'Oops, an error occurred' }) {
    const theme = useTheme();
    return (_jsxs(Wrapper, { className: className, children: [_jsx(SectionTitle, { children: title }), _jsxs(Loader, { children: [_jsx(Element, { children: _jsx(SubElement, { $color: theme.colors.black_1 }) }), _jsx(Element, { children: _jsx(SubElement, { $color: theme.colors.main }) }), _jsx(Element, { children: _jsx(SubElement, { $color: theme.colors.grey30_1 }) })] }), _jsx(Error, { children: error.message })] }));
});
